var map = {
	"./arrow.svg": 7033,
	"./arrow_back_dark.svg": 2260,
	"./arrow_left_white.svg": 334,
	"./btn-down-arrow.svg": 6746,
	"./chevron-down.svg": 6592,
	"./ck_logo.svg": 6506,
	"./emblem.svg": 9454,
	"./emblem_black.svg": 7065,
	"./eye.svg": 4423,
	"./f-i.svg": 9041,
	"./facebook.svg": 4225,
	"./footer-logo.svg": 3940,
	"./instagram.svg": 3145,
	"./list_arrow.svg": 3748,
	"./logo-main.svg": 3944,
	"./map_example.jpg": 7590,
	"./mclaut_logo.png": 9244,
	"./menu_list_arrow.svg": 7360,
	"./news_default.png": 120,
	"./sidebar_arrow.svg": 8865,
	"./telegram-blue.svg": 5459,
	"./user.svg": 4493,
	"./visual-impairment.svg": 9120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2791;